import File from './Items/File';
import Folder from './Items/Folder';
import SearchItem from './Items/SearchItem';
import NoResultPage from './NoResultPage';
const { List, Divider, withStyles } = window.Material;
import Breadcrumbs from './Breadcrumbs/Breadcrumbs';
import { ContentContext } from "../../../../utils/contexts";
import { PathPickerType } from "../../../../types/enums";

const styles = {
  list: {
    minHeight: '200px',
  },
  blurred: {
    filter: 'blur(3px)',
  },
};

class ItemList extends React.PureComponent {
  render() {
    const { classes } = this.props;
    const { content, loadingContent, breadcrumbs, searchMode } = this.context;

    const { Loader } = window.Edocat.Components;

    return (
      <div className='Item-List'>
        {breadcrumbs.length > 0 && (
          <React.Fragment>
            <Divider />
            <Breadcrumbs />
            <Divider />
          </React.Fragment>
        )}
        <div className="List-Wrapper">
          {loadingContent && <Loader />}
          {content.length > 0 && (
            <List className={`${classes.list}${loadingContent ? ` ${classes.blurred}` : ''}`} disablePadding>
              {content.map((item, index) =>
                searchMode ? <SearchItem key={item.nodeRef} item={item} index={index} /> : item.type === PathPickerType.FOLDER ? (
                  <Folder key={item.nodeRef} item={item} index={index} />
                ) : (
                  <File key={item.nodeRef} item={item} index={index} />
                )
              )}
            </List>
          )}
          {content.length < 1 && <NoResultPage />}
        </div>
      </div>
    );
  }
}

ItemList.contextType = ContentContext;

export default withStyles(styles)(ItemList);
